/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProposalSummaryOnceOffInvestment
 */
export interface ProposalSummaryOnceOffInvestment {
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryOnceOffInvestment
     */
    grossEstimatedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryOnceOffInvestment
     */
    grossCashAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryOnceOffInvestment
     */
    grossCashInvestmentAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryOnceOffInvestment
     */
    grossCashTransferAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryOnceOffInvestment
     */
    grossUnitTransferAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryOnceOffInvestment
     */
    grossAlternativeAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryOnceOffInvestment
     */
    netEstimatedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryOnceOffInvestment
     */
    netCashInvestmentAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryOnceOffInvestment
     */
    netUnitTransferAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryOnceOffInvestment
     */
    netAlternativeAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryOnceOffInvestment
     */
    annuityCashTransferAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryOnceOffInvestment
     */
    alternativeCashTransferAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryOnceOffInvestment
     */
    annuityUnitTransferAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryOnceOffInvestment
     */
    alternativeUnitTransferAmount?: number;
}

/**
 * Check if a given object implements the ProposalSummaryOnceOffInvestment interface.
 */
export function instanceOfProposalSummaryOnceOffInvestment(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProposalSummaryOnceOffInvestmentFromJSON(json: any): ProposalSummaryOnceOffInvestment {
    return ProposalSummaryOnceOffInvestmentFromJSONTyped(json, false);
}

export function ProposalSummaryOnceOffInvestmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalSummaryOnceOffInvestment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'grossEstimatedAmount': !exists(json, 'GrossEstimatedAmount') ? undefined : json['GrossEstimatedAmount'],
        'grossCashAmount': !exists(json, 'GrossCashAmount') ? undefined : json['GrossCashAmount'],
        'grossCashInvestmentAmount': !exists(json, 'GrossCashInvestmentAmount') ? undefined : json['GrossCashInvestmentAmount'],
        'grossCashTransferAmount': !exists(json, 'GrossCashTransferAmount') ? undefined : json['GrossCashTransferAmount'],
        'grossUnitTransferAmount': !exists(json, 'GrossUnitTransferAmount') ? undefined : json['GrossUnitTransferAmount'],
        'grossAlternativeAmount': !exists(json, 'GrossAlternativeAmount') ? undefined : json['GrossAlternativeAmount'],
        'netEstimatedAmount': !exists(json, 'NetEstimatedAmount') ? undefined : json['NetEstimatedAmount'],
        'netCashInvestmentAmount': !exists(json, 'NetCashInvestmentAmount') ? undefined : json['NetCashInvestmentAmount'],
        'netUnitTransferAmount': !exists(json, 'NetUnitTransferAmount') ? undefined : json['NetUnitTransferAmount'],
        'netAlternativeAmount': !exists(json, 'NetAlternativeAmount') ? undefined : json['NetAlternativeAmount'],
        'annuityCashTransferAmount': !exists(json, 'AnnuityCashTransferAmount') ? undefined : json['AnnuityCashTransferAmount'],
        'alternativeCashTransferAmount': !exists(json, 'AlternativeCashTransferAmount') ? undefined : json['AlternativeCashTransferAmount'],
        'annuityUnitTransferAmount': !exists(json, 'AnnuityUnitTransferAmount') ? undefined : json['AnnuityUnitTransferAmount'],
        'alternativeUnitTransferAmount': !exists(json, 'AlternativeUnitTransferAmount') ? undefined : json['AlternativeUnitTransferAmount'],
    };
}

export function ProposalSummaryOnceOffInvestmentToJSON(value?: ProposalSummaryOnceOffInvestment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'GrossEstimatedAmount': value.grossEstimatedAmount,
        'GrossCashAmount': value.grossCashAmount,
        'GrossCashInvestmentAmount': value.grossCashInvestmentAmount,
        'GrossCashTransferAmount': value.grossCashTransferAmount,
        'GrossUnitTransferAmount': value.grossUnitTransferAmount,
        'GrossAlternativeAmount': value.grossAlternativeAmount,
        'NetEstimatedAmount': value.netEstimatedAmount,
        'NetCashInvestmentAmount': value.netCashInvestmentAmount,
        'NetUnitTransferAmount': value.netUnitTransferAmount,
        'NetAlternativeAmount': value.netAlternativeAmount,
        'AnnuityCashTransferAmount': value.annuityCashTransferAmount,
        'AlternativeCashTransferAmount': value.alternativeCashTransferAmount,
        'AnnuityUnitTransferAmount': value.annuityUnitTransferAmount,
        'AlternativeUnitTransferAmount': value.alternativeUnitTransferAmount,
    };
}

